export const appConfig = {
    HTTP_TIMEOUT: 30000
};
